import { render, staticRenderFns } from "./SocialTypePicker.vue?vue&type=template&id=28d1a3e6&scoped=true&"
import script from "./SocialTypePicker.vue?vue&type=script&lang=js&"
export * from "./SocialTypePicker.vue?vue&type=script&lang=js&"
import style0 from "./SocialTypePicker.vue?vue&type=style&index=0&id=28d1a3e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d1a3e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCard,VIcon,VList,VListItem,VMenu})
